import { useState } from "react";

const footerNav = [
  { href: "#hot", label: "实时热榜" },
  { href: "#category", label: "现场分类" },
  { href: "#feed", label: "前排围观" },
  { href: "#guide", label: "吃瓜指南" },
  { href: "#faq", label: "常见问题" },
];

const FORM_URL = "https://readdy.ai/api/form/dadvvi3ep053ijub165g";

export default function Footer() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [msg, setMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    const honeypot = (fd.get("company_alt") as string) || "";
    if (honeypot.trim() !== "") {
      setStatus("success");
      setMsg("订阅成功,感谢你的关注,现场速递马上为你送达!");
      form.reset();
      return;
    }
    fd.delete("company_alt");

    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }
      const ok =
        res.ok &&
        parsed?.code === "OK" &&
        !/spam/i.test(parsed?.message || "") &&
        !/spam/i.test(parsed?.meta?.message || "") &&
        !/spam/i.test(parsed?.meta?.detail || "");
      if (ok) {
        setStatus("success");
        setMsg("订阅成功,感谢你的关注,现场速递马上为你送达!");
        form.reset();
      } else {
        setStatus("error");
        setMsg(
          parsed?.meta?.message ||
            parsed?.message ||
            parsed?.meta?.detail ||
            "订阅失败,请稍后再试"
        );
      }
    } catch {
      setStatus("error");
      setMsg("网络异常,订阅未能完成,请稍后再试");
    }
  };

  return (
    <footer id="contact" className="bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <a href="#top" className="flex items-center gap-2" aria-label="爆炸瓜首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-accent-500 text-primary-950">
                <i className="ri-vidicon-2-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-display text-2xl text-background-50">爆炸瓜</span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-200/80">
              爆炸瓜是吃瓜群众的聚集地,提供吃瓜指南与在线吃瓜入口。
              前排围观最新现场,热门事件边吃边追,轻松跟上节奏。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-weibo-line", "ri-wechat-line", "ri-douban-line", "ri-bilibili-line"].map(
                (ic) => (
                  <a
                    key={ic}
                    href="#contact"
                    aria-label="社交媒体入口"
                    className="flex h-9 w-9 items-center justify-center rounded-full border border-background-200/30 text-background-200 transition hover:border-accent-400 hover:bg-accent-500 hover:text-primary-950"
                  >
                    <i className={ic} aria-hidden="true"></i>
                  </a>
                )
              )}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 md:col-span-1">
            <div>
              <h3 className="text-sm font-bold text-background-50">栏目导航</h3>
              <ul className="mt-4 space-y-3">
                {footerNav.map((l) => (
                  <li key={l.href}>
                    <a
                      href={l.href}
                      className="text-sm text-background-200/80 transition hover:text-accent-300"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-bold text-background-50">吃瓜指引</h3>
              <ul className="mt-4 space-y-3 text-sm text-background-200/80">
                <li>理性吃瓜指南</li>
                <li>社区讨论公约</li>
                <li>隐私政策</li>
                <li>纠错反馈</li>
              </ul>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50">订阅现场速递</h3>
            <p className="mt-4 text-sm text-background-200/80">
              留下邮箱,热门现场第一时间送到你手上,不错过任何一波瓜。
            </p>
            <form
              onSubmit={handleSubmit}
              data-readdy-form="dadvvi3ep053ijub165g"
              className="mt-4"
            >
              <label htmlFor="footer-email" className="sr-only">
                邮箱地址
              </label>
              <div className="flex flex-col gap-2 sm:flex-row">
                <input
                  id="footer-email"
                  type="email"
                  name="email"
                  required
                  placeholder="你的邮箱"
                  className="w-full rounded-full border border-background-200/30 bg-background-50/10 px-4 py-2.5 text-sm text-background-50 outline-none placeholder:text-background-200/50 focus:border-accent-400"
                />
                <button
                  type="submit"
                  className="shrink-0 rounded-full bg-accent-500 px-5 py-2.5 text-sm font-semibold text-primary-950 whitespace-nowrap transition hover:bg-accent-400"
                >
                  订阅
                </button>
              </div>
              <div className="mt-2" aria-hidden="true">
                <label htmlFor="company_alt" className="sr-only">
                  公司名称
                </label>
                <input
                  type="text"
                  id="company_alt"
                  name="company_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="footer-hp-input"
                />
              </div>
              {status === "success" && (
                <p className="mt-2 text-xs text-accent-300">{msg}</p>
              )}
              {status === "error" && (
                <p className="mt-2 text-xs text-primary-200">{msg}</p>
              )}
            </form>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-200/15 pt-6 sm:flex-row">
          <p className="text-xs text-background-200/70">
            © 2026 爆炸瓜 · 吃瓜群众聚集地 · 理性围观,友善讨论
          </p>
          <p className="text-xs text-background-200/50">先吃为敬,边吃边追</p>
        </div>
      </div>
    </footer>
  );
}